import { Controller } from "@hotwired/stimulus"

const COLORS = ["gray","red","orange","amber","green","blue","purple","pink"]
const COLOR_CLASSES = {
  gray:   "bg-well text-ink-slate",
  red:    "bg-red-50 text-red-700",
  orange: "bg-orange-50 text-orange-700",
  amber:  "bg-amber-50 text-amber-700",
  green:  "bg-green-50 text-green-700",
  blue:   "bg-brand/[.08] text-brand-deep",
  purple: "bg-purple-50 text-purple-700",
  pink:   "bg-pink-50 text-pink-700",
}

export default class extends Controller {
  static targets = ["addButton", "inputWrapper", "input"]

  showInput(event) {
    event.stopPropagation()
    this.addButtonTarget.style.display = "none"
    const wrapper = this.inputWrapperTarget
    wrapper.style.display = "inline-flex"
    wrapper.classList.add("tag-input-enter")
    setTimeout(() => this.inputTarget.focus(), 10)
  }

  handleSubmit(event) {
    const name = this.inputTarget.value.trim()
    if (!name) {
      event.preventDefault()
      this.#hideInput()
      return
    }
    // Insert chip immediately — frame update from server will replace it with
    // the confirmed version once the roundtrip completes.
    const form = event.target
    this.element.insertBefore(this.#buildChip(name), form)
    // Turbo's submitBubbled reads FormData synchronously during the submit event
    // dispatch. Defer the clear until after that so the server receives the name.
    queueMicrotask(() => {
      this.inputTarget.value = ""
      this.inputTarget.focus()
    })
  }

  handleKey(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.inputTarget.closest("form")?.requestSubmit()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.#hideInput()
    }
  }

  handleBlur() {
    setTimeout(() => {
      if (!this.element.contains(document.activeElement)) this.#hideInput()
    }, 120)
  }

  // Animate the chip out, then let the remove form submit via Turbo.
  removeChip(event) {
    const chip = event.currentTarget.closest(".tag-chip")
    if (!chip) return
    event.preventDefault()
    const form = event.currentTarget.closest("form")
    const submit = () => { chip.style.display = "none"; if (form) form.requestSubmit() }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      submit()
      return
    }

    chip.classList.add("tag-exit")
    chip.addEventListener("animationend", submit, { once: true })
  }

  #hideInput() {
    this.inputTarget.value = ""
    this.inputWrapperTarget.style.display = "none"
    this.inputWrapperTarget.classList.remove("tag-input-enter")
    this.addButtonTarget.style.display = ""
  }

  #buildChip(name) {
    let h = 0
    for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) & 0xffff
    const color = COLORS[h % (COLORS.length - 1) + 1]
    const classes = COLOR_CLASSES[color] || COLOR_CLASSES.gray
    const chip = document.createElement("span")
    chip.className = `tag-chip tag-enter inline-flex items-center rounded-full px-3 py-1.5 text-[14px] font-semibold cursor-default ${classes}`
    const label = document.createElement("span")
    label.textContent = name
    chip.appendChild(label)
    return chip
  }
}
